var modules_59ffffaf = {"wrapper":"CommonError_module_wrapper__79651bc6"};
import "../../../assets/esm/components/CommonError/CommonError~BKVnVMjV.css";

export { modules_59ffffaf as default };
//# sourceMappingURL=CommonError.module.less.js.map
